const SIZE = {
  STANDARD: "standard",
  COMPACT: "compact",
  EXTENDED: "extended"
};
export {
  SIZE
};
